import { FormDialogComponent, FormDialogOptions } from './form-dialog/form-dialog.component';
import { FormularzFormly } from './../formly/formularz-formly';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { PopupDialogComponent } from './popup-dialog/popup-dialog.component';
import { DialogType } from './DialogType';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export class DialogResult {
  modalRef: NgbModalRef
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private modalService: NgbModal) {
  }

  confirm(title: string, content?: string): Observable<any> {
    return this.createDialogSubject(ConfirmDialogComponent, title, content);
  }

  alert(title: string, content?: string): Observable<any> {
    return this.createDialogSubject(AlertDialogComponent, title, content);
  }

  private createDialogSubject(component: any, title: string, content: string) {
    const subject = new Subject();
    const modalRef = this.modalService.open(component, {});
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = content;
    modalRef.result.then(() => {
      subject.next();
    }, () => { });
    return subject;
  }

  popupInfo(message: string, time: number = 500): NgbModalRef {
    return this.popup(DialogType.INFO, message, time);
  }

  popupSuccess(message: string, time: number = 500): NgbModalRef {
    return this.popup(DialogType.SUCCESS, message, time);
  }

  popupWarning(message: string, time: number = 500): NgbModalRef {
    return this.popup(DialogType.WARNING, message, time);
  }

  popupError(message: string, time: number = 500): NgbModalRef {
    return this.popup(DialogType.ERROR, message, time);
  }

  private popup(type: DialogType, message: string, time: number = 500): NgbModalRef {
    const modalRef = this.modalService.open(PopupDialogComponent, {});
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.time = time;
    return modalRef;
  }

  messageInfo(message: string): NgbModalRef {
    return this.message(DialogType.INFO, message);
  }

  messageSuccess(message: string): NgbModalRef {
    return this.message(DialogType.SUCCESS, message);
  }

  messageWarning(message: string): NgbModalRef {
    return this.message(DialogType.WARNING, message);
  }

  messageError(message: string): NgbModalRef {
    return this.message(DialogType.ERROR, message);
  }

  private message(type: DialogType, message: string): NgbModalRef {
    const modalRef = this.modalService.open(MessageDialogComponent, {});
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.message = message;
    return modalRef;
  }

  //TODO: przemyslec jeszcze raz sygnature metody showForm
  showForm<T>(
    form: FormularzFormly<T>,
    formDialogOptions?: FormDialogOptions,
    options: NgbModalOptions = {}
  ): FormDialogComponent<T> {
    const modalRef = this.modalService.open(FormDialogComponent, options);
    (modalRef.componentInstance as FormDialogComponent<T>).initForm(form, formDialogOptions);
    return modalRef.componentInstance;
  }


  /**
   * Opens a new modal window with the specified content and supplied options.
   *
   * Content can be provided as a `TemplateRef` or a component type. If you pass a component type as content,
   * then instances of those components can be injected with an instance of the `NgbActiveModal` class. You can then
   * use `NgbActiveModal` methods to close / dismiss modals from "inside" of your component.
   *
   * Also see the [`NgbModalOptions`](#/components/modal/api#NgbModalOptions) for the list of supported options.
   */
  open(content: any, params: any = {}, options?: NgbModalOptions): NgbModalRef {
    const modalRef = this.modalService.open(content, options);
    for (const [key, value] of Object.entries(params)) {
      modalRef.componentInstance[key] = value;
    }
    return modalRef;
  }
  /**
  * Dismisses all currently displayed modal windows with the supplied reason.
  *
  */
  dismissAll(reason?: any): void {
    this.modalService.dismissAll();
  }
  /**
   * Indicates if there are currently any open modal windows in the application.
   */
  hasOpenModals(): boolean {
    return this.modalService.hasOpenModals();
  }
}
